var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": " \\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.14 96.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u56FE\\u5C42_2",
    "data-name": " \\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discord_Logos",
    "data-name": "Discord Logos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discord_Logo_-_Large_-_White",
    "data-name": "Discord Logo - Large - White"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.7,8.07c-8.35-3.82-17.17-6.54-26.23-8.07-1.24,2.22-2.36,4.5-3.36,6.83-9.65-1.45-19.46-1.45-29.11,0-1-2.33-2.12-4.61-3.36-6.83-9.06,1.55-17.89,4.27-26.25,8.09C2.79,32.65-1.71,56.6.54,80.21h0c9.72,7.18,20.6,12.65,32.17,16.15,2.6-3.5,4.91-7.22,6.89-11.11-3.76-1.4-7.39-3.14-10.85-5.18.91-.66,1.8-1.34,2.66-2,20.37,9.58,43.95,9.58,64.32,0,.87.71,1.76,1.39,2.66,2-3.46,2.05-7.1,3.78-10.87,5.19,1.98,3.89,4.28,7.6,6.89,11.1,11.58-3.49,22.47-8.95,32.19-16.14h0c2.64-27.38-4.51-51.11-18.9-72.15ZM42.45,65.69c-6.27,0-11.45-5.69-11.45-12.69s5-12.74,11.43-12.74,11.57,5.74,11.46,12.74-5.05,12.69-11.44,12.69ZM84.69,65.69c-6.28,0-11.44-5.69-11.44-12.69s5-12.74,11.44-12.74,11.54,5.74,11.43,12.74-5.04,12.69-11.43,12.69Z",
    fill: "#fff",
    strokeWidth: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordIcon);
export default __webpack_public_path__ + "static/media/discordIcon.7efb3f8722515c757a2411fdd6b157c5.svg";
export { ForwardRef as ReactComponent };